import React, { useState, useEffect } from 'react'
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import AddStreamDialog from '../add-stream-dialog/AddStreamDialogContainer'
import StreamCard from '../StreamCard'
import NewWindow from '../../../utils/NewWindow'
import defaultImage from '../../../assets/images/TestBanner.png'

const styles = theme => ({
  addStreamContainer: {
    margin: theme.spacing.unit
  },
  addStreamButton: {
    float: 'left'
  },
  cardsContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  }
})

const MyEvents = ({ classes, isLoading, streams, fetchMyStreams, fetchRemoveMyEvent, updateMyEvent }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (streams === undefined) {
      fetchMyStreams()
    }
  })
  // stores the visibility of AddStreamDialog
  const [open, setOpen] = useState(false)

  // stores the state of the stream pop-up
  const [startStream, setStartStream] = useState(false)

  const [editingStream, setEditingStream] = useState(null)

  return (
    <>
      <div className={classes.addStreamContainer}>
        {/* Button to trigger visibility of AddStreamDialog */}
        <Button onClick={() => setOpen(true)} variant='contained' color='primary'
          className={classes.addStreamButton}>
          {t('Cabinet:create stream')}
        </Button>

        <AddStreamDialog
          open={open}
          onClose={() => {
            setOpen(false)
            setEditingStream(null)
          }}
          editingStream={editingStream}
          updateMyEvent={updateMyEvent}
        />
      </div>

      {/* Container for current user's streams */}
      <div className={classes.cardsContainer}>
        {
          streams && streams.map(stream => {
            const startDate = new Date(`${stream.startDate}Z`)
            return (
              <StreamCard key={stream.id}
                image={`data:image/jpeg;base64,${stream.avatarBytes}`}
                title={stream.title}
                descr={stream.description}
                price={`${stream.price} $`}
                removeStream={fetchRemoveMyEvent}
                editStream={() => {
                  setEditingStream(stream)
                  setOpen(true)
                }}
                id={stream.id}
                startDate={startDate}
                actionLabel={t('Cabinet:start stream')}
                onStartStream={() => setStartStream(true)} />)
          })
        }
      </div>

      {startStream && (<NewWindow url={'/webcam'} width={800} height={600} onUnload={() => setStartStream(false)} />)}
    </>
  )
}

export default withStyles(styles)(MyEvents)
